export enum SlideshowMode {
    OneSlide = 'OneSlide',
    ThreeSlides = 'ThreeSlides',
}

export enum ArrowDirection {
    Left = 'left',
    Right = 'right',
}

export enum NavigationMode {
    Swipe = 'swipe',
    Arrows = 'arrows',
}
